export default __webpack_public_path__ + "static/media/order-of-commitment.ab8b0ce0.svg";